import { RequestBuilder } from '../request_builder'

export class WebshopRequestBuilder extends RequestBuilder {
  constructor (serverUrl) {
    super(serverUrl)
    this.segment = 'webshop'
  }

  getDetails (ticketID) {
    this.filters.push('ticket')
    this.filters.push(ticketID)
    return this
  }
}



// WEBPACK FOOTER //
// ./src/js/builders/request_builder/modules/webshop_request_builder.js